const PsChartsDataCVS =  {
        'MATÉRIA PRIMA': [
            ['psAtrPcts', 'psAtrDigestor'],
            ['psFibraCana', 'psBagacoCana'],
            ['', ''],
        ],
        'MOAGEM': [
            ['psUptimeGeral', 'psDiasSafra'],
            ['psTaxaMoagem', 'psMoagemTotal'],
            ['', ''],
        ],
        'EFICIÊNCIAS': [
            ['psArtEntrado', 'psArtRecuperado'],
            ['psEficienciaIndustrial', 'psRTC'],
            ['psConsVaporTc', 'psPtConsumidaTC']
        ],
        'PERDAS': [
            ['psPerdaBagaco', 'psPerdaLavavem'],
            ['psPerdaTorta', 'psPerdaMultijato'],
            ['psPerdaFermentacao', 'psPerdaResiduaria'],
            ['psPerdaIndeterminada', '']
        ],
        'PRODUÇÕES': [
            ['psProdAcucarTotalSC', 'psProdEtanolTotalHid'],
            ['psEnergiaGerada', 'psEnergiaExportada'],
            ['psEnergiaConsumidaInd', ''],
            
        ],
        'ESTOQUES': [
            ['psEstoqueInicialBag', 'psEstoqueFinalBag'],
            ['', ''],
            ['', ''],
        ],
        'PAGE1': [
            ['psAtrDigestor', 'psFibraCana'],
            ['psUptimeGeral', 'psMoagemTotal'],
            ['psTaxaMoagem', 'psRTC'],
        ],
        'PAGE2': [
            ['psProdAcucarTotalSC', 'psProdEtanolTotalHid'],
            ['psProdEtanolAnidro', 'psEnergiaExportada'],
            ['', '']
            // ['psEnergiaConsumidaInd', 'psEnergiaConsumidaAgr'],
        ]
    }

export default PsChartsDataCVS;

